var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85411 0.317967C1.42986 -0.106274 0.742011 -0.106274 0.31776 0.317967C-0.10649 0.742208 -0.10649 1.43004 0.317761 1.85428L6.46357 7.99996L0.317974 14.1454C-0.106276 14.5697 -0.106277 15.2575 0.317974 15.6817C0.742224 16.106 1.43007 16.106 1.85432 15.6817L7.99992 9.53627L14.1449 15.6811C14.5691 16.1053 15.257 16.1053 15.6812 15.6811C16.1055 15.2569 16.1055 14.569 15.6812 14.1448L9.53627 7.99996L15.6814 1.85492C16.1057 1.43068 16.1057 0.742851 15.6814 0.31861C15.2572 -0.105631 14.5693 -0.105631 14.1451 0.31861L7.99992 6.46365L1.85411 0.317967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.639c89d559f9f085da7c19cafcca2475.svg";
export { ForwardRef as ReactComponent };